// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class UnpublishMapAction implements flatbuffers.IUnpackableObject<UnpublishMapActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):UnpublishMapAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsUnpublishMapAction(bb:flatbuffers.ByteBuffer, obj?:UnpublishMapAction):UnpublishMapAction {
  return (obj || new UnpublishMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsUnpublishMapAction(bb:flatbuffers.ByteBuffer, obj?:UnpublishMapAction):UnpublishMapAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new UnpublishMapAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapUnpublishMap;
}

static startUnpublishMapAction(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapUnpublishMap);
}

static endUnpublishMapAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createUnpublishMapAction(builder:flatbuffers.Builder, type:ActionType):flatbuffers.Offset {
  UnpublishMapAction.startUnpublishMapAction(builder);
  UnpublishMapAction.addType(builder, type);
  return UnpublishMapAction.endUnpublishMapAction(builder);
}

unpack(): UnpublishMapActionT {
  return new UnpublishMapActionT(
    this.type()
  );
}


unpackTo(_o: UnpublishMapActionT): void {
  _o.type = this.type();
}
}

export class UnpublishMapActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapUnpublishMap
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return UnpublishMapAction.createUnpublishMapAction(builder,
    this.type
  );
}
}
